import { APIGatewayService } from "@core/gateway/APIGateway.service";
import { AppInjector } from "@core/injector/injector.module";
import { AppConfigService } from '@configuration/app.config.service';
import { IBaseModuleComponent } from '../component/IBaseComponent';

export abstract class BaseEndpoint implements IBaseModuleComponent {
    ControllerName: string;

    ModuleName: string = AppInjector.get(AppConfigService).getModuleNameByInstance(this);

    constructor(
        ControllerName: string,
        protected api: APIGatewayService) {
        this.ControllerName = `${this.ModuleName}/${ControllerName}`;
    }

    GetControllerURL(): string {
        return this.api.GetAPIURL() + this.ControllerName;
    }

}